import React from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { setMapChoice } from '../../actions'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'
import LayersIcon from '@mui/icons-material/Layers'
import { styled } from '@mui/material/styles'

export default function BackgroundMap() {
  const { mapChoice } = useSelector(state => state)
  const dispatch = useDispatch()
  const [open, setOpen] = React.useState(false)
  const imgStyle = { margin: '5px', cursor: 'pointer' }

  const LayersIconStyled = styled(LayersIcon)({
    [`&.MuiSvgIcon-root`]: {
      color: '#333',
    },
  })

  function Switch(e) {
    console.log(e.target.id)
    dispatch(setMapChoice(e.target.id))
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <Button className="layer-icon" style={{}} onClick={handleClickOpen}>
        <LayersIconStyled />
      </Button>
      <Dialog disableEscapeKeyDown open={open} onClose={handleClose}>
        <DialogTitle className="dialogbox-title">
          Choose a Background Map
        </DialogTitle>
        <DialogContent>
          <form>
            <FormControl>
              <div
                role="list"
                className="u_cms-list map-styles w-dyn-items"
                style={{ display: 'flex', flexDirection: 'row' }}
              >
                <div role="listitem" className="maps_map-item w-dyn-item">
                  <img
                    id="light-v9"
                    value="light-v9"
                    checked={mapChoice === 'light-v9'}
                    onClick={Switch}
                    width="100"
                    //images taken from https://www.mapbox.com/maps
                    src="https://assets.website-files.com/5e83362767d71ffd59a0c8a9/5e9db83e241283e854d764ed_light_ma.jpg"
                    alt=""
                    className="u_map-card w-inline-block"
                    style={imgStyle}
                  />
                </div>
                <div role="listitem" className="maps_map-item w-dyn-item">
                  <img
                    id="dark-v9"
                    value="dark-v9"
                    checked={mapChoice === 'dark-v9'}
                    onClick={Switch}
                    width="100"
                    src="https://assets.website-files.com/5e83362767d71ffd59a0c8a9/5e9ec9b5babce63530d2abe1_dark_map%402x.jpg"
                    alt=""
                    className="u_map-card w-inline-block"
                    style={imgStyle}
                  />
                </div>
                <div role="listitem" className="maps_map-item w-dyn-item">
                  <img
                    id="streets-v9"
                    value="streets-v9"
                    checked={mapChoice === 'streets-v9'}
                    onClick={Switch}
                    width="100"
                    src="https://assets.website-files.com/5e83362767d71ffd59a0c8a9/5e9d812a8a5e0b00a064f7a6_streets_map.jpg"
                    alt=""
                    className="u_map-card w-inline-block"
                    style={imgStyle}
                  />
                </div>
                <div role="listitem" className="maps_map-item w-dyn-item">
                  <img
                    id="outdoors-v9"
                    value="outdoors-v9"
                    checked={mapChoice === 'outdoors-v9'}
                    onClick={Switch}
                    width="100"
                    src="https://assets.website-files.com/5e83362767d71ffd59a0c8a9/5e9ee8c5d3a57f68749a9d7c_height_map%402x.jpg"
                    alt=""
                    className="u_map-card w-inline-block"
                    style={imgStyle}
                  />
                </div>
                <div role="listitem" className="maps_map-item w-dyn-item">
                  <img
                    id="satellite-v9"
                    value="satellite-v9"
                    checked={mapChoice === 'satellite-v9'}
                    onClick={Switch}
                    width="100"
                    src="https://assets.website-files.com/5e83362767d71ffd59a0c8a9/5e9ee324e5e26229d0b82546_sat_map%402x.jpg"
                    alt=""
                    className="u_map-card w-inline-block"
                    style={imgStyle}
                  />
                </div>
              </div>
            </FormControl>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
